import React from "react";
import { LANDING } from "../../constants/testIds";
import TypeformButton from "./TypeformButton";
import heroBg from "@/assets/nuovo-sfondo-back.png";

export default function Hero() {
  return (
    <header
      className="relative pt-[42vh] pb-16 lg:py-32 overflow-hidden bg-cover [background-position:72%_center] lg:[background-position:35%_center]"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      {/* La foto e' orizzontale: su schermi stretti "cover" taglia i lati e riempie
          esattamente l'altezza, quindi il volto non si puo' spostare in basso con
          background-position. Sotto lg si sposta invece il testo: pt-[42vh] lo fa
          partire sotto il viso, che resta scoperto nella fascia alta. Da lg il
          testo occupa la colonna di sinistra e il problema non si pone. */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-chocolate/15 via-chocolate/45 to-chocolate/85 lg:bg-none lg:bg-chocolate/30"
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Text Content */}
        <div className="lg:col-span-7 flex flex-col items-start space-y-8 z-10 font-sans">
          <div className="space-y-4">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-champagne">
              IL PERCORSO DI TRASFORMAZIONE PERSONALE PER DONNE
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-ivory font-editorial leading-[1.15]">
              Ritrova il tuo valore, <br className="hidden sm:inline" />
              liberati dagli schemi, <br />
              <span className="italic font-normal text-champagne">torna a te stessa.</span>
            </h1>
          </div>

          <p className="text-base sm:text-lg leading-relaxed text-ivory/90 max-w-xl font-light">
            {"Un percorso individuale esclusivo di 60 giorni per disconnetterti dalle dinamiche affettive tossiche, ristabilire i tuoi confini e smettere di rincorrere l'amore da uno stato di insicurezza."}
          </p>

          <TypeformButton
            className="bg-champagne-light text-chocolate hover:bg-champagne text-sm font-semibold tracking-widest px-8 py-5 rounded-none transition-luxury inline-block"
            testId={LANDING.ctaApplyHero}
          >
            INIZIA IL TUO VIAGGIO - CANDIDATI ORA
          </TypeformButton>
        </div>
      </div>
    </header>
  );
}
